import type { JSX } from 'react'

export const AngleDownIcon = (): JSX.Element => (
  <use href='#angleDownIcon' height='100%' width='100%' />
)
